var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "config-signs",
      attrs: {
        title: "Configurar firmas",
        "no-close-on-backdrop": "",
        size: "xl",
        "cancel-title": "Cancelar",
        "ok-title": "¡Listo!",
        id: "config-signs"
      },
      on: { cancel: _vm.cancelModal }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("StepSignaturePositionTemplate", {
              attrs: {
                file: _vm.file,
                steps: _vm.steps,
                signaturesDropped: _vm.signatures
              },
              on: { "sign-position": _vm.getSignPosition }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }